import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white, link, borderColor } from 'styles/colors'
import { relevanceSelector } from 'selectors'

import Type from './Type'

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const List = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 13px;
`

const Tag = styled.div`
  ${({ type }) => (type ? '' : 'color: ' + link)};
  position: relative;
  background-color: ${white};
  ${({ type }) => (type ? 'border: 1px solid ' + borderColor : '')};
  border-radius: 4px;
  padding: 5px 10px;
  margin: 16px 7px 0 7px;
`

const Relevance = ({ relevance, tokens }) =>
  relevance.length ? (
    <Wrapper>
      <List>
        {relevance.map(({ term, type }) => (
          <Tag key={term} type={type}>
            {term}
            <Type type={type} />
          </Tag>
        ))}
      </List>
    </Wrapper>
  ) : null

const mapStateToProps = (state, { consultantId }) => ({
  relevance: relevanceSelector(state, consultantId) || [],
})

export default connect(mapStateToProps)(Relevance)



// WEBPACK FOOTER //
// ./src/components/ConsultantList/Consultant/Relevance/index.js